export const Logs = (error) => {
  return new Error(error);
};
